<template>
    <span>
        <v-card class="white" height="100%">
            <v-toolbar dense dark color="#ef4044" flat>
                <v-toolbar-title><v-icon>mdi-certificate</v-icon> &nbsp; Mis AOCs&nbsp;&nbsp;</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon text @click="onClose" v-on="on">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Cerrar</span>
                </v-tooltip>
            </v-toolbar>
            <v-card-title>Paquetes seleccionados</v-card-title>
            <v-card-text>
                <v-container fluid>
                    <v-row v-for="(paquete, i) in userAOCs.paquetes" dense>
                        <v-col cols="12">
                            <v-card
                                class="pa-3 my-course-card"
                                ourlined
                            >
                                <v-row
                                    v-if="$vuetify.breakpoint.smAndDown"
                                    justify="center"
                                    align="center"
                                    dense
                                >
                                    <v-col cols="1">
                                        <v-tooltip left>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon @click="unselectPackage(paquete.paqueteid, paquete.paquete)" v-on="on">
                                                    <v-icon color="red darken-2">
                                                        mdi-minus-circle
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Quitar paquete</span>
                                        </v-tooltip>
                                    </v-col>                    
                                </v-row>
                                <v-row justify="space-between" align="center" dense>
                                    <v-col
                                        cols="auto"
                                        md="10"
                                        class="d-flex justify-left font-weight-medium uia-red"
                                        :class="{'subtitle-1': $vuetify.breakpoint.mdAndUp, 'subtitle-1': $vuetify.breakpoint.smAndDown}"
                                    >
                                    {{ paquete.paquete }}
                                    </v-col>
                                    <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="auto">
                                        <v-tooltip left>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon @click="unselectPackage(paquete.paqueteid, paquete.paquete)" v-on="on">
                                                    <v-icon color="red darken-2">
                                                        mdi-minus-circle
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Quitar paquete</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                                <v-divider color="#ef4044"></v-divider>
                                <br>
                                <v-row dense>
                                    <v-col cols="12" md="5">
                                        <v-card>
                                            <v-toolbar height="20" dark flat color="#ef4044">
                                                <v-toolbar-title class="my-list-subtitle">Departamento</v-toolbar-title>
                                            </v-toolbar>
                                            <v-list
                                                subheader
                                                dense
                                                :height="departamentosListHeight"
                                                max-height="100%"
                                                class="overflow-y-auto overflow-x-auto"
                                                outlined
                                                flat
                                            >
                                                <v-list-item
                                                    class="my-list-item"
                                                    v-for="(depto, j) in paquete.departamentos"
                                                    :key="j"
                                                >
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            {{ depto.departamento }}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" md="5">
                                        <v-card>
                                            <v-toolbar height="20" dark flat color="#ef4044">
                                                <v-toolbar-title class="my-list-subtitle">División</v-toolbar-title>
                                            </v-toolbar>
                                            <v-list
                                                subheader
                                                dense
                                                :height="departamentosListHeight"
                                                max-height="100%"
                                                class="overflow-y-auto overflow-x-auto"
                                                outlined
                                                flat
                                            >
                                                <v-list-item
                                                    class="my-list-item"
                                                    v-for="(depto, j) in paquete.departamentos"
                                                    :key="j"
                                                >
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            {{ depto.division }}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider class="mx-4"></v-divider>
            
            <v-card-title>Materias seleccionadas</v-card-title>
            <v-card-text>
                <v-container fluid>
                    <v-row v-for="(materia, k) in userAOCs.materias" dense>
                        <v-col cols="12">
                            <v-card
                                class="pa-3 my-course-card"
                                ourlined
                            >
                                <v-row
                                    v-if="$vuetify.breakpoint.smAndDown"
                                    justify="center"
                                    align="center"
                                    dense
                                >
                                    <v-col cols="1">
                                        <v-tooltip left>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon @click="unselectCourse(materia.materiaid, materia.materia)" v-on="on">
                                                    <v-icon color="red darken-2">
                                                        mdi-minus-circle
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Quitar materia</span>
                                        </v-tooltip>
                                    </v-col>                    
                                </v-row>
                                <v-row justify="space-between" align="center" dense>
                                    <v-col
                                        cols="auto"
                                        md="10"
                                        class="d-flex justify-left font-weight-medium uia-red"
                                        :class="{'subtitle-1': $vuetify.breakpoint.mdAndUp, 'subtitle-1': $vuetify.breakpoint.smAndDown}"
                                    >
                                    {{ materia.clave }} - {{ materia.materia}}
                                    </v-col>
                                    <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="auto">
                                        <v-tooltip left>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon @click="unselectCourse(materia.materiaid, materia.materia)" v-on="on">
                                                    <v-icon color="red darken-2">
                                                        mdi-minus-circle
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Quitar materia</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                                <v-divider color="#ef4044"></v-divider>
                                <br>
                                <v-row dense>
                                    <v-col cols="12" md="4">
                                        <v-textarea
                                            label="Paquete"
                                            v-model="materia.paquete"
                                            no-resize
                                            color="red darken-1"
                                            readonly
                                            rows="2"
                                            dense
                                            outlined
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-card>
                                            <v-toolbar height="20" dark flat color="#ef4044">
                                                <v-toolbar-title class="my-list-subtitle">Departamento</v-toolbar-title>
                                            </v-toolbar>
                                            <v-list
                                                subheader
                                                dense
                                                :height="departamentosListHeight"
                                                max-height="100%"
                                                class="overflow-y-auto overflow-x-auto"
                                                outlined
                                                flat
                                            >
                                                <v-list-item
                                                    class="my-list-item"
                                                    v-for="(depto, j) in materia.departamentos"
                                                    :key="j"
                                                >
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            {{ depto.departamento }}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-card>
                                            <v-toolbar height="20" dark flat color="#ef4044">
                                                <v-toolbar-title class="my-list-subtitle">División</v-toolbar-title>
                                            </v-toolbar>
                                            <v-list
                                                subheader
                                                dense
                                                :height="departamentosListHeight"
                                                max-height="100%"
                                                class="overflow-y-auto overflow-x-auto"
                                                outlined
                                                flat
                                            >
                                                <v-list-item
                                                    class="my-list-item"
                                                    v-for="(depto, j) in materia.departamentos"
                                                    :key="j"
                                                >
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            {{ depto.division }}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn
                        color="teal darken-3"
                        class="text-none"
                        text
                        @click="onClose"
                    >OK</v-btn>
            </v-card-actions>
        </v-card>
        <!-- Modal para confirmar borrado de paquete: **************************************** -->
        <v-dialog v-model="bDeletingPackage" persistent width="auto">
            <v-card class="grey lighten-4">
                <v-toolbar dense color="orange darken-4" dark flat>
                    <v-toolbar-title class="my-list-title">Borrar Paquete</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon>mdi-delete</v-icon>
                </v-toolbar><v-card-title class="text-center">
                    <div style="margin: auto">
                        <v-icon large color="orange darken-3">mdi-alert</v-icon>
                    </div>
                    &nbsp; ¿Deseas quitar el paquete {{ selectedPackageName }}"?
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="teal darken-3"
                        class="text-none"
                        text
                        @click="confirmUnselectPackage"
                        >OK
                    </v-btn>
                    <v-btn
                        color="pink darken-1"
                        class="text-none"
                        text
                        @click="cancelUnselectPackage"
                        >Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Termina Modal para confirmar borrado de paquete *************************** -->

        <!-- Modal para confirmar borrado de materia: **************************************** -->
        <v-dialog v-model="bDeletingCourse" persistent width="auto">
            <v-card class="grey lighten-4">
                <v-toolbar dense color="orange darken-4" dark flat>
                    <v-toolbar-title class="my-list-title">Borrar Materia</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon>mdi-delete</v-icon>
                </v-toolbar><v-card-title class="text-center">
                    <div style="margin: auto">
                        <v-icon large color="orange darken-3">mdi-alert</v-icon>
                    </div>
                    &nbsp; ¿Deseas quitar la materia {{ selectedCourseName }}"?
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="teal darken-3"
                        class="text-none"
                        text
                        @click="confirmUnselectCourse"
                        >OK
                    </v-btn>
                    <v-btn
                        color="pink darken-1"
                        class="text-none"
                        text
                        @click="cancelUnselectCourse"
                        >Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Termina Modal para confirmar borrado de materia *************************** -->
    </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'package_info',
    data() {
        return {
            packageID: 0,
            courseID: 0,
            bDeletingPackage: false,
            bDeletingCourse: false,
            selectedPackageName: '',
            selectedCourseName: '',
        };
    },

    created() {
        //console.log("showAOCsByPackage = ", this.showAOCsByPackage);
    },

    props: {
        showAOCsByPackage: String,
    },
    
    methods: {
        onClose() {
            this.myAOCsDlg = false;
        },

        unselectPackage(packageID, packageName)
        {
            this.packageID = packageID;
            this.selectedPackageName = packageName;
            this.bDeletingPackage = true;
        },

        cancelUnselectPackage()
        {
            this.packageID = 0;
            this.selectedPackageName = '';
            this.bDeletingPackage = false;
        },

        confirmUnselectPackage()
        {
            this.bDeletingPackage = false;

            for (let i = 0; i < this.userAOCs.paquetes.length; i ++)
            {
                if (this.userAOCs.paquetes[i].paqueteid === this.packageID)
                {
                    this.userAOCs.paquetes.splice(i, 1);
                    break;
                }
            }

            //Si actualmente en la vista principal se tiene el catálogo por paquetes, el paquete se pone como
            //no seleccionad0 en el catálogo:

            if (this.showAOCsByPackage === '1')
            {
                var bPaqueteEncontrado = false;
                //console.log("catalogoAOCs = ", this.catalogoAOCs);
                for (let i = 0; i < this.catalogoAOCs.length; i ++)
                {
                    for (let j = 0; j < this.catalogoAOCs[i].departamentos.length; j ++)
                    {
                        for (let k = 0; k < this.catalogoAOCs[i].departamentos[j].paquetes.length; k ++)
                        {
                            if (this.catalogoAOCs[i].departamentos[j].paquetes[k].paqueteid === this.packageID)
                            {
                                this.catalogoAOCs[i].departamentos[j].paquetes[k].seleccionado = false;
                                bPaqueteEncontrado = true;
                                break;
                            }
                        }
                        if (bPaqueteEncontrado)
                        {
                            break;
                        }
                    }
                    if (bPaqueteEncontrado)
                    {
                        break;
                    }
                }
            }

            //console.log("userAOCs = ", this.userAOCs);
                
            //Se elimina el paquete de la BD:
            this.$store.dispatch('unselectPackage', this.packageID);

            this.packageID = 0;
            this.selectedPackageName = '';
            this.bDeletingPackage = false;
        },

        unselectCourse(courseID, courseName)
        {
            this.courseID = courseID;
            this.selectedCourseName = courseName;
            this.bDeletingCourse = true;
        },

        cancelUnselectCourse()
        {
            this.courseID = 0;
            this.selectedCourseName = '';
            this.bDeletingCourse = false;
        },

        confirmUnselectCourse()
        {
            for (let i = 0; i < this.userAOCs.materias.length; i ++)
            {
                if (this.userAOCs.materias[i].materiaid === this.courseID)
                {
                    this.userAOCs.materias.splice(i, 1);
                    break;
                }
            }

            //Si actualmente en la vista principal se tiene el catálogo por asignaturas, la materia se pone como
            //no seleccionada en el catálogo:

            if (this.showAOCsByPackage !== '1')
            {
                //console.log("showAOCsByPackate = '2'...");
                var bMateriaEncontrada = false;
                //console.log("catalogoAOCS = ", this.catalogoAOCs);
                for (let i = 0; i < this.catalogoAOCs.length; i ++)
                {
                    for (let j = 0; j < this.catalogoAOCs[i].departamentos.length; j ++)
                    {
                        for (let k = 0; k < this.catalogoAOCs[i].departamentos[j].materias.length; k ++)
                        {
                            if (this.catalogoAOCs[i].departamentos[j].materias[k].materiaid === this.courseID)
                            {
                                this.catalogoAOCs[i].departamentos[j].materias[k].seleccionada = false;
                                bMateriaEncontrada = true;
                                break;
                            }
                        }
                        if (bMateriaEncontrada)
                        {
                            break;
                        }
                    }
                    if (bMateriaEncontrada)
                    {
                        break;
                    }
                }
            }

            //console.log("userAOCs = ", this.userAOCs);
                
            //Se elimina la materia de la BD:
            this.$store.dispatch('unselectCourse', this.courseID);

            this.courseID = 0;
            this.selectedCourseName = '';
            this.bDeletingCourse = false;
        }
        
    },

    computed:
    {
        ...mapGetters([
            'waitCursor',
        ]),

        departamentosListHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '74px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '74px';
            } else {
                height = '74px';
            }
            return height;
        },

        myAOCsDlg: {
            get() {
                return this.$store.getters.myAOCsDlg;
            },
            set(myAOCsDlg) {
                this.$store.dispatch('updateMyAOCsDlg', myAOCsDlg)
            },
        },

        userAOCs: {
            get() {
                return this.$store.getters.userAOCs;
            },
            set(userAOCs) {
                this.$store.dispatch('updateUserAOCs', userAOCs)
            },
        },

        catalogoAOCs: {
            get() {
                return this.$store.getters.catalogoAOCs;
            },
            set(catalogoAOCs) {
                this.$store.dispatch('updateCatalogoAOCs', catalogoAOCs)
            },
        },

    }
};
</script>

<style scoped>

.uia-red {
    color:#ef4044!important;
}

.my-course-card
{
    border-width: 10px;
    border-color: #BDBDBD!important;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}

.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}

.my_pointer {
    cursor: pointer;
}

a:link,
a:visited {
    color: #c62828;
    text-decoration: none;
}

a:link:active,
a:visited:active {
    color: #c62828;
}

</style>